// export const BASE_APP_URL = "http://localhost:3000";
// export const BASE_API = "http://localhost:8000/api";
export const BASE_APP_URL = "https://beta.sheet.codexlab.co";
export const BASE_API = "https://api.beta.sheet.codexlab.co/api";

export const BASE_URL = "https://www.codexlab.co";
export const BASE_PATH = "";

export const UNKNOWN_ERROR_MESSAGE = "Something went wrong! Please try again.";

export const LESS_SECURE_KEY =
  "This is a fake key. Not the real one. - zxc5zcx62JGcxbzx45)*Jxca5115240d21555cb574d98b13ff65";

export const rootElement = document.getElementById("root");
